module.exports = __webpack_public_path__ + "img/img3.6b80a114.jpg";